import { Tabs } from "antd";
import React, { useState } from "react";
import PurchaseOrderListReport from "./PurchaseOrderListReport";
import ProductReceiveListReport from "./ProductReceiveListReport";

export default function MainPurchaseReport() {
  const [tabChange, setTabChange] = useState(null);

  const handleTabChange = (value) => {
    setTabChange(value);
  };
  const items = [
    {
      key: "Purchase Order List",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Purchase Order List
        </div>
      ),
      children: <PurchaseOrderListReport tabChange={tabChange} />,
    },
    {
      key: "Product Receive List",
      label: (
        <div className="text-center" style={{ color: "#46604A" }}>
          Product Receive List
        </div>
      ),
      children: <ProductReceiveListReport tabChange={tabChange} />,
    },
  ];
  return (
    <>
      <div className="shadow-sm rounded">
        <Tabs
          onChange={handleTabChange}
          className="px-4 mt-4 custom-tabs"
          defaultActiveKey="Purchase Order List"
          items={items}
        />
      </div>
    </>
  );
}
